// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"96b5d17e","93":"8ee6a9b6","141":"5d2f898a","382":"c9e8277d","422":"9c284ef2","453":"dc2e7c95","468":"370c0442","532":"a89ee206","574":"a154d2ad","632":"afea17c5","677":"717cc166","875":"13d6edd6","898":"44247330"}[chunkId] + ".chunk.js";
};